import axios from 'axios';
// import { getToken } from './UserFunctions';
import { decryptAES, isSet, parameterizedURLAccessToken } from './CommonFunctions';
import { IsEncrypted } from "../envConfig";
// import {failMessage} from '../store/actions/CommonActions';
// import store from '../store';
import { INACTIVE_USER_MSG } from '../Global/Constants';

// import * as ShipConstants from '../Global/Constants';

const configAxios = axios;
// declare a request interceptor
configAxios.interceptors.request.use(config => {
	// perform a task before the request is sent
	// console.log('Request was sent');
	let customHeaders = {};
    if(IsEncrypted===true){
        customHeaders = {
            'X-Encrypted-Data':'dHJ1ZQ=='
        }
    }
	config.headers  = {
		...customHeaders,
		...config.headers,
	}
	return config;
}, error => {
	// handle the error
	return Promise.reject(error);
});
// declare a response interceptor
configAxios.interceptors.response.use((response) => {
	// do something with the response data
	// console.log('Response was received');
	const {config} = response;
	// console.log('config',config);
    let isEnc = false;
    try{
        isEnc = (isSet(config.headers['X-Encrypted-Data'],null)!==null)?true:false;
    }catch(e){

    }
	try{
		let returnResponse = {...response};
		// console.log('returnResponse1',returnResponse);
		if(isSet(response.status,response.statusCode)===200){
			const resData = response.data;
			//  console.log('resData1',resData);
			// console.log('resData',isEnc,resData);
			returnResponse = {
				...returnResponse,
				data:{
					...resData,
					data:isEnc===true?decryptAES(resData.data):resData.data,
				}
			}
			// console.log('returnRes',returnResponse.data);
		}
		return returnResponse;
	}catch(e){
		return null;
	}
	
}, error => {
	// handle the response error
	console.log(error);
	const res = error.response;
    const resData = res.data ;
	if(res && res.status === 401 && resData.code==401 && INACTIVE_USER_MSG.some(msg =>
                resData.message.toLowerCase().includes(msg.toLowerCase())
            )){
				// console.log('resData-expired');
				// const {dispatch} = store;
				localStorage.removeItem('access_token');
				localStorage.removeItem('refresh_token');
				// dispatch(failMessage(resData.message));
				localStorage.setItem('LoggedOutMsg',resData.message);
				const el = document.querySelector('.viewport');
                const el1 = document.querySelector('.main-panel');
                if (el1) {
                    el1.style.display = 'none';
                }else if (el) {
                    el.style.display = 'none';
                }
				document.location.href ='/login';
				localStorage.removeItem('user');
				localStorage.removeItem('moduleId');
				
			}
	// console.log(error.response.data.error==="invalid_token");
	if(error.response && error.response.data.error==="invalid_token"){
		// const {dispatch} = store;
		// console.log('invalid token');
		localStorage.removeItem('access_token');
		localStorage.removeItem('refresh_token');
		localStorage.removeItem('user');
		localStorage.removeItem('moduleId');
		// dispatch(failMessage(error.response.data.message));
		document.location.href ='/login';
	}
	else if(error.response && (error.response.status===403)){
		console.log(error.response);
		// const {dispatch} = store;
		// dispatch(failMessage(error.response.data.message));
		//For checking session is expired or not and redirect to login page.
		
	}
	return Promise.reject(error);
});

export const callGET = (url) => {

	// sent a GET request
  	return configAxios.get(parameterizedURLAccessToken(url));
	// let response = axios.get(parameterizedURLAccessToken(url))
	// .catch(error => {
	// 	if (error.response) {
	// 		// Request made and server responded
	// 		console.log(error.response.data);
	// 		console.log(error.response.status);
	// 		console.log(error.response.headers);
	// 		const erorRes = error.response;
	// 		console.log(erorRes);
	// 		if(erorRes.status===403){
	// 			//For checking session is expired or not and redirect to login page.
	// 			localStorage.removeItem('access_token');
	// 			localStorage.removeItem('refresh_token');
	// 			localStorage.removeItem('user');
	// 			localStorage.removeItem('moduleId');
	// 			document.location.href ='/login';
	// 		}
	// 	  } else if (error.request) {
	// 		// The request was made but no response was received
	// 		console.log(error.request);
	// 	 } else {
	// 		// Something happened in setting up the request that triggered an Error
	// 		console.log('Error', error.message);
	// 	  }
	//   });
	// // console.log(response);
	//  return response;
}

export const callPOST = (url, body, header) => {
	return configAxios.post(parameterizedURLAccessToken(url), body, {
	  headers: header
	});
}

export const callPUT = (url, body, header) => {
	// console.log("callPUT",url);
	/*return axios.put(url, body, {
	  headers: {
	    header
	  }
	});*/
	return configAxios.put(parameterizedURLAccessToken(url), body, {
	  headers: header
	});
}

export const callDELETE = (url,body={}) => {
	console.log("callDELETE----->",url,body);
	return configAxios.delete(parameterizedURLAccessToken(url),{ data: body });
}

export const callDELETEREQUEST = (url, body, header) => {
	console.log("callDELETEREQUEST----->",url);
	return configAxios.delete(parameterizedURLAccessToken(url), {params: body}, header);
}

export const callGETASYNC = async (url,header="") => {
	/*const response = await axios.get(ShipConstants.API_URL+url+'?access_token='+getToken());
    console.log("callGETASYNC",url);
    return response.data;*/
    const response =  await configAxios.get(parameterizedURLAccessToken(url));
    return response.data;
}

export const callPOSTASYNC = async (url,body, header) => {
	const response =  await configAxios.post(parameterizedURLAccessToken(url),body);
    return response.data;
}

export const callPUTASYNC = () => {
	alert(12);
}

export const callDELETEASYNC = () => {
	alert(12);
}

export const callGETFULLURL = (url) => {
  	return axios.get(url);
}

export const callAPIUsingName = (method,url,body,header) => {

	switch (method) {
		case 'post' :
			return configAxios.post(parameterizedURLAccessToken(url), body, {
			  headers: header
			});
			// break;
		case 'put' :
			return configAxios.put(parameterizedURLAccessToken(url), body, {
			  headers: header
			});
			// break;
		case 'get' :
			return configAxios.get(parameterizedURLAccessToken(url));
			// break;
		default:
			return configAxios.get(parameterizedURLAccessToken(url));
	}
}